<template>
  <v-container v-if="hasError">
    <empty-state>
      <template v-slot:icon>
        <v-icon color="error">mdi-alert</v-icon>
      </template>
      <template v-slot:description>
        Ocorreu um erro durante o carregamentos do seu carrinho,
        por favor tente novamente mais tarde
      </template>
    </empty-state>
  </v-container>
  <v-container
    v-else
    fluid
    class="fill-height"
  >
    <v-row
      class="ma-0"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="8"
      >
        <v-card
          :loading="isLoading"
          elevation="10"
        >
          <v-card-title class="grey lighten-2">Produtos</v-card-title>
          <v-divider/>
          <v-scale-transition
            hide-on-leave
          >
            <v-skeleton-loader
              v-if="isLoading"
              :loading="isLoading"
              type="article, article, article"
              class="ma-2"
            />
            <v-flex
              v-else-if="shoppingCartIsEmpty"
            >
              <v-container
                fluid
              >
                <v-row class="ma-0">
                  <empty-state color="primary">
                    <template v-slot:icon>
                      <v-icon color="primary">mdi-cart-off</v-icon>
                    </template>
                    <template v-slot:description>
                      <span>Seu carrinho está vazio</span>
                    </template>
                  </empty-state>
                </v-row>
              </v-container>
            </v-flex>
            <v-flex
              v-else
            >
              <v-container
                fluid
                class="fill-height"
                v-for="item in processingCart"
                :key="item['cd_processing']"
              >
                <cart-item :item="item"/>
                <v-row class="ma-0 pa-2">
                  <v-btn
                    text
                    small
                    color="error"
                    :loading="isDeleting"
                    @click="() => onDeleteShoppingCartProcessing(item['id_shopping_cart_processing'])"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    Remover
                  </v-btn>
                  <v-spacer/>
                  <v-switch
                    label="Créditos"
                    :loading="processingCartCreditsActive[item['id_shopping_cart_processing']]['loading'] || isDeleting"
                    v-model="processingCartCreditsActive[item['id_shopping_cart_processing']]['active']"
                    @change="(event) => { onCreditsChangeProcessing(event, item) }"
                    hide-details
                    :disabled="!canApplyCredits && !processingCartCreditsActive[item['id_shopping_cart_processing']]['active']"
                    class="ma-0"
                  />
                </v-row>
                <v-row class="ma-0">
                  <v-divider/>
                </v-row>
              </v-container>

              <v-container                
                fluid
                class="fill-height"
                v-for="item in postProcessingCart"
                :key="item['id_shopping_cart_post_processing']"
              >
                <cart-item :item="item"/>
                <v-row class="ma-0 pa-2">
                  <v-btn
                    text
                    small
                    color="error"
                    :loading="isDeleting"
                    @click="() => onDeleteShoppingCartPostProcessing(item['id_shopping_cart_post_processing'])"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    Remover
                  </v-btn>
                  <v-spacer/>
                  <v-switch
                    label="Créditos"
                    :loading="postProcessingCartCreditsActive[item['id_shopping_cart_post_processing']]['loading'] || isDeleting"
                    v-model="postProcessingCartCreditsActive[item['id_shopping_cart_post_processing']]['active']"
                    @change="(event) => { onCreditsChangePostProcessing(event, item) }"
                    hide-details
                    :disabled="!canApplyCredits && !postProcessingCartCreditsActive[item['id_shopping_cart_post_processing']]['active']"
                    class="ma-0"
                    v-if="chargeTypeIsCredits"
                  />
                </v-row>
                <v-row class="ma-0">
                  <v-divider/>
                </v-row>
              </v-container>

              <v-container
                fluid
                class="fill-height"
                v-for="item in subscriptionCart"
                :key="item['id_shopping_cart_subscription']"
              >
                <cart-item :item="item"/>
                <v-row class="ma-0 pa-2">
                  <v-btn
                    text
                    small
                    color="error"
                    :loading="isDeleting"
                    @click="() => onDeleteShoppingCartSubscription(item['id_shopping_cart_subscription'])"
                  >
                    <v-icon left>mdi-delete</v-icon>
                    Remover
                  </v-btn>
                </v-row>
                <v-row class="ma-0">
                  <v-divider/>
                </v-row>
              </v-container>
            </v-flex>
          </v-scale-transition>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
      >
        <v-card
          :loading="isLoading"
          elevation="10"
          hover
        >
          <v-card-title class="grey lighten-2">Total</v-card-title>
          <v-divider/>
          <v-scale-transition
            hide-on-leave
          >
            <v-skeleton-loader
              v-if="isLoading"
              :loading="isLoading"
              type="article, actions"
              class="ma-2"
            />
            <v-container
              v-else
              fluid
              class="fill-height"
            >
              <cart-summary :item="shoppingCart"/>
              <v-row
                align="start"
                justify="space-between"
                class="ma-0"
              >
                <v-col
                  cols="8"
                >
                  <v-text-field
                    v-model="strCoupon"
                    label="Cupom"
                    clearable
                    outlined
                    dense
                  />
                </v-col>
                <v-col
                  cols="4"
                >
                  <v-row
                    class="ma-0"
                  >
                    <v-spacer/>
                    <v-btn
                      color="success"
                    >
                      <span>Aplicar</span>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-scale-transition>
        </v-card>
        <v-card
          elevation="10"
          class="mt-4 py-1 px-3"
          v-if="chargeTypeIsCredits"
        >
          <v-container
            fluid
          >
            <span class="subtitle-1 font-weight-regular">Você tem <b class="blue--text">{{flTotalCredits | toFixedWithComma}}</b> créditos</span>
          </v-container>
        </v-card>
        <v-card
          elevation="10"
          class="mt-4 py-1 px-3"
          v-if="!chargeTypeIsCredits"
        >
          <v-container
            fluid
          >
            <div v-for="item in list_user_packages" :key="item.hectare_package.id_type_hectare_package"><span class="subtitle-1 font-weight-regular">Saldo Pacote <b>{{ item.hectare_package.nm_hectare_package }}</b> <b class="blue--text">{{ item.float_total_hectares | toFixedWithComma}}</b> ha</span><br></div>
          </v-container>
        </v-card>        
      </v-col>
    </v-row>
    <v-row
      class="ma-0 my-2"
    >
      <v-divider/>
    </v-row>
    <v-row
      v-if="!shoppingCartIsEmpty"
      class="ma-0"
    >
      <v-spacer/>
      <v-btn
        v-if="isNoType"
        color="success"
        @click="initPaymentNoType"
        :loading="isLoadingBoaCompraInfo || PaymentMixin.isPaying"
      >
        Finalizar compra
      </v-btn>
      <v-btn
        v-else-if="isHostedCheckout"
        color="success"
        @click="initPaymentHostedCheckout"
        :loading="isLoadingBoaCompraInfo || PaymentMixin.isPaying"
      >
        Finalizar compra
      </v-btn>
      <v-btn
        v-else
        color="primary"
        @click="onNextClick"
        :loading="PaymentMixin.isPaying"
      >
        Próximo
      </v-btn>
    </v-row>

    <form ref="hostedCheckoutForm" method="POST" name="billing" action="https://billing.boacompra.com/payment.php">
      <input type="hidden" name="store_id" id="store_id" :value="hostedCheckoutData.storeId">
      <input type="hidden" name="return" :value="hostedCheckoutData.return">
      <input type="hidden" name="notify_url" :value="hostedCheckoutData.notifyUrl">
      <input type="hidden" name="currency_code" id="currency_code" :value="hostedCheckoutData.currencyCode">
      <input type="hidden" name="order_id" id="order_id" :value="hostedCheckoutData.orderId">
      <input type="hidden" name="order_description" :value="hostedCheckoutData.description">
      <input type="hidden" name="amount" id="amount" :value="hostedCheckoutData.amount">
      <input type="hidden" name="client_email" id="client_email" :value="hostedCheckoutData.email">
      <input type="hidden" name="hash_key" id="hash_key" :value="hostedCheckoutData.hashKey">
      <input type="hidden" name="test_mode" id="test_mode" :value="hostedCheckoutData.testMode">
      <input
        type="hidden" name="country_payment" id="country_payment"
        :value="hostedCheckoutData.strPaymentCountry"
      >
      <input type="hidden" name="language" id="language" :value="hostedCheckoutData.language">
    </form>
  </v-container>
</template>

<script>
  import {
    deletePostProcessingCart,
    deleteProcessingCart, deleteSubscriptionCart,
    getActiveShoppingCart, getUserCredits, updatePostProcessingCart,
    updateProcessingCart, getAfterProcessingItens, getUserTotalHectarePackage,
    getDataPackageHectareCart, getListUserPackages, consumeHectarePackage
  } from "../../../api/api-billing"
  import store from "../../../store"
  import {GET_USER_DATA} from "../../../store/modules/user"
  import {debounce} from "lodash/function"
  import {find, forEach, includes} from "lodash/collection"
  import CartItem from "./CartItem"
  import CartSummary from "./CartSummary"
  import {gt, isEmpty, isEqual} from "lodash/lang"
  import EmptyState from "../../Helpers/EmptyState"
  import {eq, lt} from "lodash/lang"
  import {PAYMENT_COUNTRY, PAYMENT_COUNTRY_LANGUAGE, PAYMENT_METHOD} from "../../../helpers/payment/constants"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../../helpers/notify"
  import {DIALOG_TYPES, DialogOptions} from "../../../helpers/dialogs"
  import {UserData} from "../../../api/api-auth"
  import {FRONTEND_URL} from "../../../globals"

  const PaymentNextStep = Symbol.for("PaymentNextStep")
  const SetShoppingCart = Symbol.for("SetShoppingCart")
  const SetPaymentMethod = Symbol.for("SetPaymentMethod")
  const InitPayment = Symbol.for("InitPayment")
  const _PaymentMixin = Symbol.for("_PaymentMixin")

  export default {
    name: "ShoppingCart",
    inject: {NextStep: PaymentNextStep, SetShoppingCart, SetPaymentMethod, InitPayment, _PaymentMixin},
    components: {EmptyState, CartSummary, CartItem},
    data: () => ({
      isLoading: true,
      isDeleting: false,
      hasError: false,

      strCoupon: null,

      shoppingCart: null,

      processingCart: null,
      processingCartCreditsActive: null,

      postProcessingCart: null,
      postProcessingCartCreditsActive: null,

      subscriptionCart: null,

      flUserCreditsConverted: 0,

      hostedCheckoutData: {
        currencyCode: "USD",
        storeId: null,
        return: `${FRONTEND_URL}/app/processing-list`,
        notifyUrl: null,
        orderId: null,
        description: null,
        amount: null,
        email: null,
        hashKey: null,
        testMode: null,
        strPaymentCountry: null,
        language: null,
      },
      isLoadingBoaCompraInfo: false,

      insufficient_funds: false,
      count_packages_consume: 0,
      list_user_packages: null
    }),
    methods: {
      onNextClick() {
        if (this.verifyNoType()) {
          this.initPaymentNoType()
        } else {
          this.NextStep()
        }
      },
      initPaymentNoType() {
        this.isLoadingBoaCompraInfo = true
        if(this.chargeTypeIsCredits) {
          this.configurePayment()
        } else {
            this.insufficient_funds = false
            forEach(this.postProcessingCart , item => {
              let dataProcessing = {
                "str_crop_type": item.price_post_processing.crop_type.ab_crop_type ,
                "str_analysis_type": item.price_post_processing.agronomic_analyzes.ab_analysis_type
              }               
              getAfterProcessingItens(this.$apiAuth.getAuthToken(), dataProcessing)
              .then((res) => {              
                const data = res.data.data
                const userData = store.getters[GET_USER_DATA]
                let dataSend = {
                  "cd_user": userData.idUserAccount,
                  "id_type_hectare_package": data.cd_hectare_package
                }
                getUserTotalHectarePackage(this.$apiAuth.getAuthToken(), dataSend)
                .then((res) => {   
                  const TotalHectar =  res.data.data.total_hectar                  
                  let sendData = {
                    "ab_analysis_type": item.price_post_processing.agronomic_analyzes.ab_analysis_type,
                    "ab_crop_type": item.price_post_processing.crop_type.ab_crop_type,
                    "cd_field_post_processing": item.cd_field_post_processing
                  }
                  
                  getDataPackageHectareCart(this.$apiAuth.getAuthToken(), sendData)
                  .then(res => {
                    const data = res.data.data
                    if(lt(TotalHectar, data.total_hectares)) { 
                      this.insufficient_funds = true                   
                      this.$dialog(new DialogOptions({
                        title: "Aviso",
                        content: `Saldo insuficiente para o Pacote de Hectare: <b>${data.type_package}</b>. <br> Saldo atual: <b>${data.total_hectares} ha</b>`,
                        type: DIALOG_TYPES.ALERT
                      }))                       
                    }
                  })
                  .catch(() => {
                    this.$notify(new NotificationOptions({
                      message: "Não foi possível obter os dados do pacote",
                      type: NOTIFICATION_TYPES.ERROR
                    }))
                  })
                })
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "Ocorreu algum erro ao solicitar total de package hectare, tente novamente mais tarde.",
                  type: NOTIFICATION_TYPES.ERROR
                }))
              })
            }) 
            setTimeout(() => this.checkConfirmInsufficientFunds(), 1000)             
            setTimeout(() => this.isLoadingBoaCompraInfo = false, 10000)
        }
      },
      checkConfirmInsufficientFunds() {
        if(!this.insufficient_funds){
          this.count_packages_consume = 0
          forEach(this.postProcessingCart , item => {
            let sendData = {
              "ab_analysis_type": item.price_post_processing.agronomic_analyzes.ab_analysis_type,
              "ab_crop_type": item.price_post_processing.crop_type.ab_crop_type,
              "cd_field_post_processing": item.cd_field_post_processing
            }
            
            getDataPackageHectareCart(this.$apiAuth.getAuthToken(), sendData)
            .then(res => {
              const data = res.data.data
              let total_remove = data.total_hectares

              let sendData = {
                "str_analysis_type": item.price_post_processing.agronomic_analyzes.ab_analysis_type,
                "str_crop_type": item.price_post_processing.crop_type.ab_crop_type,
                "float_total_remove": total_remove,
                "cd_field_post_processing": item.cd_field_post_processing
              }
              consumeHectarePackage(this.$apiAuth.getAuthToken(), sendData)
              .then(() => {
                this.count_packages_consume++
              })
              .catch(() => {
                this.onDeleteShoppingCartPostProcessing(item['id_shopping_cart_post_processing'])
                this.$notify(new NotificationOptions({
                  message: `Não foi possível concluir a solicitação para ${item.price_post_processing.crop_type.ab_crop_type} - ${item.price_post_processing.agronomic_analyzes.ab_analysis_type}`,
                  type: NOTIFICATION_TYPES.ERROR
                }))
              }) 
            })
            .catch(() => {
              this.$notify(new NotificationOptions({
                message: "Não foi possível obter total de área",
                type: NOTIFICATION_TYPES.ERROR
              }))
            })    
          }) 
          setTimeout(() => this.configurePayment(), 1000)                  
        }
      },      
      configurePayment() {
        this.SetPaymentMethod(PAYMENT_METHOD.NO_TYPE)
        this.InitPayment(this.$apiAuth.getAuthToken())
          .then(() => {
            this.$notify(new NotificationOptions({
              message: "Compra realizada com sucesso, redirecionando",
              type: NOTIFICATION_TYPES.SUCCESS
            }))
            setTimeout(() => {
              this.$router.push("/app/processing-list")
            }, 3000)
          })
      },
      initPaymentHostedCheckout() {
        this.SetPaymentMethod(PAYMENT_METHOD.BOACOMPRA)
        this.isLoadingBoaCompraInfo = true
        this.InitPayment(this.$apiAuth.getAuthToken())
          .then((res) => {
            const hostedCheckout = res.data.data

            this.hostedCheckoutData.amount = hostedCheckout["amount"]
            this.hostedCheckoutData.hashKey = hostedCheckout["hash_key"]
            this.hostedCheckoutData.notifyUrl = hostedCheckout["notify_url"]
            this.hostedCheckoutData.orderId = hostedCheckout["order_id"]
            this.hostedCheckoutData.storeId = hostedCheckout["store_id"]
            this.hostedCheckoutData.testMode = hostedCheckout["test_mode"]
            this.hostedCheckoutData.description = hostedCheckout["transaction"]["cd_reference"]

            this.$notify(new NotificationOptions({
              message: "Informações coletadas com sucesso, redirecionando para o BoaCompra",
              type: NOTIFICATION_TYPES.SUCCESS
            }))

            setTimeout(() => {
              this.$refs["hostedCheckoutForm"].submit()
            }, 1000)
          })
          .finally(() => {
            this.isLoadingBoaCompraInfo = false
          })
      },
      verifyNoType() {
        if (!this.shoppingCart) return false
        return eq(this.shoppingCart["fl_final_price"], 0)
      },
      onDeleteShoppingCartProcessing(cdShoppingCartProcessing) {
        this.isDeleting = true
        deleteProcessingCart(this.$apiAuth.getAuthToken(), cdShoppingCartProcessing)
          .then(res => {
            const shoppingCart = res.data.data
            this.SetShoppingCart(shoppingCart)

            this.shoppingCart = shoppingCart
            this.processingCart = shoppingCart["processing_cart"]
            this.postProcessingCart = shoppingCart["post_processing_cart"]
            this.subscriptionCart = shoppingCart["subscription_cart"]

            const length = shoppingCart["processing_cart"].length + shoppingCart["post_processing_cart"].length + shoppingCart["subscription_cart"].length
            this.$appMng.setShoppingCartLength(length)
          })
          .finally(() => {
            this.isDeleting = false
          })
      },
      onCreditsChangeProcessing: debounce(function (value, item) {
        const cardData = {
          bl_use_credits: value
        }
        this.processingCartCreditsActive[item["id_shopping_cart_processing"]]['loading'] = true
        updateProcessingCart(this.$apiAuth.getAuthToken(), item["id_shopping_cart_processing"], cardData)
          .then(res => {
            const shoppingCart = res.data.data
            this.SetShoppingCart(shoppingCart)

            this.shoppingCart = shoppingCart
            this.processingCart = shoppingCart["processing_cart"]
            forEach(shoppingCart["processing_cart"], item => {
              this.processingCartCreditsActive[item["id_shopping_cart_processing"]]['active'] = item["fl_credits_discount"] !== 0
            })
            this.postProcessingCart = shoppingCart["post_processing_cart"]
            this.subscriptionCart = shoppingCart["subscription_cart"]
          })
          .finally(() => {
            this.processingCartCreditsActive[item["id_shopping_cart_processing"]]['loading'] = false
          })
      }, 500),

      onDeleteShoppingCartPostProcessing(cdShoppingCartPostProcessing) {
        this.isDeleting = true
        deletePostProcessingCart(this.$apiAuth.getAuthToken(), cdShoppingCartPostProcessing)
          .then(res => {
            const shoppingCart = res.data.data
            this.SetShoppingCart(shoppingCart)

            this.shoppingCart = shoppingCart
            this.processingCart = shoppingCart["processing_cart"]
            this.postProcessingCart = shoppingCart["post_processing_cart"]
            this.subscriptionCart = shoppingCart["subscription_cart"]

            const length = shoppingCart["processing_cart"].length + shoppingCart["post_processing_cart"].length + shoppingCart["subscription_cart"].length
            this.$appMng.setShoppingCartLength(length)
          })
          .finally(() => {
            this.isDeleting = false
          })
      },
      onCreditsChangePostProcessing: debounce(function (value, item) {
        const cardData = {
          bl_use_credits: value
        }
        this.postProcessingCartCreditsActive[item["id_shopping_cart_post_processing"]]['loading'] = true
        updatePostProcessingCart(this.$apiAuth.getAuthToken(), item["id_shopping_cart_post_processing"], cardData)
          .then(res => {
            const shoppingCart = res.data.data
            this.SetShoppingCart(shoppingCart)

            this.shoppingCart = shoppingCart
            this.processingCart = shoppingCart["processing_cart"]
            this.postProcessingCart = shoppingCart["post_processing_cart"]
            forEach(shoppingCart["post_processing_cart"], item => {
              this.postProcessingCartCreditsActive[item["id_shopping_cart_post_processing"]]['active'] = item["fl_credits_discount"] !== 0
            })
            this.subscriptionCart = shoppingCart["subscription_cart"]
          })
          .finally(() => {
            this.postProcessingCartCreditsActive[item["id_shopping_cart_post_processing"]]['loading'] = false
          })
      }, 500),

      onDeleteShoppingCartSubscription(cdShoppingCartSubscription) {
        this.isDeleting = true
        deleteSubscriptionCart(this.$apiAuth.getAuthToken(), cdShoppingCartSubscription)
          .then(res => {
            const shoppingCart = res.data.data
            this.SetShoppingCart(shoppingCart)

            this.shoppingCart = shoppingCart
            this.processingCart = shoppingCart["processing_cart"]
            this.postProcessingCart = shoppingCart["post_processing_cart"]
            this.subscriptionCart = shoppingCart["subscription_cart"]

            const length = shoppingCart["processing_cart"].length + shoppingCart["post_processing_cart"].length + shoppingCart["subscription_cart"].length
            this.$appMng.setShoppingCartLength(length)
          })
          .finally(() => {
            this.isDeleting = false
          })
      },
    },
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },      
      PaymentMixin() {
        return this._PaymentMixin()
      },
      isNoType() {
        if (!this.shoppingCart) return false
        return eq(this.shoppingCart["fl_final_price"], 0)
      },
      shoppingCartIsEmpty() {
        if (!this.shoppingCart) return true
        return isEmpty(this.processingCart) && isEmpty(this.postProcessingCart) && isEmpty(this.subscriptionCart)
      },
      flTotalCredits() {
        if (!this.shoppingCart) return this.flUserCreditsConverted
        return (this.flUserCreditsConverted - this.shoppingCart["fl_credits_discount"])
      },
      canApplyCredits() {
        return gt(this.flTotalCredits, 0)
      },
      isHostedCheckout() {
        return this.$appMng.isIntl
      }
    },
    created() {
      const getActiveShoppingCartPromise = getActiveShoppingCart(this.$apiAuth.getAuthToken())
        .then(res => {
          const shoppingCart = res.data.data
          this.SetShoppingCart(shoppingCart)

          this.shoppingCart = shoppingCart

          this.processingCart = Object.assign({}, this.processingCart, shoppingCart["processing_cart"])
          let processingCartCreditsActive = {}
          forEach(shoppingCart["processing_cart"], item => {
            processingCartCreditsActive[item["id_shopping_cart_processing"]] = {
              active: item["fl_credits_discount"] !== 0,
              loading: false
            }
          })
          this.processingCartCreditsActive = processingCartCreditsActive   
          this.postProcessingCart = shoppingCart["post_processing_cart"]          

          let postProcessingCartCreditsActive = {}
          forEach(shoppingCart["post_processing_cart"], item => {
            postProcessingCartCreditsActive[item["id_shopping_cart_post_processing"]] = {
              active: item["fl_credits_discount"] !== 0,
              loading: false
            }
          })
          this.postProcessingCartCreditsActive = postProcessingCartCreditsActive

          this.subscriptionCart = shoppingCart["subscription_cart"]
        })
        .catch(() => {
          this.hasError = true
        })     

      const getUserCreditsPromise = getUserCredits(this.$apiAuth.getAuthToken())
        .then(res => {
          const userCredits = res.data.data
          this.flUserCreditsConverted = userCredits["int_user_credits"] / 100
        })
        .catch(() => {
          this.hasError = true
        })

      const whoamiPromise = this.$apiAuth.whoami()
        .then((response) => {
          const userData = UserData.fromObject(response.data)
          this.hostedCheckoutData.email = userData.strEmail

          if (!includes(PAYMENT_COUNTRY, userData.abCountry))
            this.hostedCheckoutData.strPaymentCountry = "US"
          else
            this.hostedCheckoutData.strPaymentCountry = userData.abCountry

          const countryLanguage = find(PAYMENT_COUNTRY_LANGUAGE, (value, key) => isEqual(key, userData.abCountry))

          if (countryLanguage)
            this.hostedCheckoutData.language = countryLanguage
          else
            this.hostedCheckoutData.language = find(PAYMENT_COUNTRY_LANGUAGE, (value, key) => isEqual(key, "DEFAULT"))

        })

        const getListUserPackagePromisse = getListUserPackages(this.$apiAuth.getAuthToken())
        .then(res => {
          const listData = res.data.data
          this.list_user_packages = listData
        })
        .catch(() => {
        })

      Promise.all([getActiveShoppingCartPromise, getUserCreditsPromise, whoamiPromise, getListUserPackagePromisse])
        .finally(() => {      
          this.isLoading = false
        })
    }  
  }
</script>

<style scoped>

</style>
